interface String {
  /**
   * Determines whether two strings are equivalent in the albanian locale.
   * @param that String to compare to target string
   */
  albanianCompare(that?: string): number;

  /**
   * Replaces the last character of a text in a string if the condition applies.
   * @param searchValue A string to search for.
   * @param replaceValue A string containing the text to replace the last successful match of searchValue in this string.
   */
  replaceLast(searchValue: string, replaceValue?: string): string;

  /**
   * Replaces the last occurrence of a text in a string.
   * @param searchValue A string to search for.
   * @param replaceValue A string containing the text to replace the last successful match of searchValue in this string.
   */
  replaceLastOccurrence(searchValue: string, replaceValue?: string): string;

  /**
   * Converts the first characters (if it's alphabetical) in a string to uppercase.
   */
  capitalize(): string;
}

String.prototype.albanianCompare = function (that: string): number {
  const albanianAlphabet: string[] = [
    'a',
    'b',
    'c',
    'ç',
    'd',
    'dh',
    'e',
    'ë',
    'f',
    'g',
    'gj',
    'h',
    'i',
    'j',
    'k',
    'l',
    'll',
    'm',
    'n',
    'nj',
    'o',
    'p',
    'q',
    'r',
    'rr',
    's',
    'sh',
    't',
    'th',
    'u',
    'v',
    'x',
    'xh',
    'y',
    'z',
    'zh',
  ];
  const albanianAlphabetRegex = new RegExp('(dh|gj|ll|nj|rr|sh|th|xh|zh|.)');

  const firstArray = this.toLowerCase()
    .split(albanianAlphabetRegex)
    .filter((s) => s != '');
  const secondArray = that
    .toLowerCase()
    .split(albanianAlphabetRegex)
    .filter((s) => s != '');

  for (let i = 0; i < firstArray.length; i++) {
    if (!secondArray[i]) {
      return 1;
    }
    if (albanianAlphabet.indexOf(firstArray[i]) == -1 || albanianAlphabet.indexOf(secondArray[i]) == -1) {
      let lc = firstArray[i].localeCompare(secondArray[i]);
      if (lc != 0) return lc;
    }
    if (albanianAlphabet.indexOf(firstArray[i]) > albanianAlphabet.indexOf(secondArray[i])) {
      return 1;
    } else if (albanianAlphabet.indexOf(firstArray[i]) < albanianAlphabet.indexOf(secondArray[i])) {
      return -1;
    }
  }
  if (secondArray.length > firstArray.length) {
    return -1;
  }
  return 0;
};

// String.prototype.replaceLast = function (searchValue: string, replaceValue: string = ''): string {
//   if (searchValue[searchValue.length - 1].toLowerCase() == replaceValue.toLowerCase())
//     return this.replace(new RegExp(searchValue + '([^' + searchValue + ']*)$'), replaceValue + '$1');
//   return this.toString();
// };

String.prototype.replaceLast = function (searchValue, replaceValue) {
  const lastIndex = this.lastIndexOf(searchValue);
  if (lastIndex >= 0 && lastIndex == this.length - searchValue.length) {
    return this.substring(0, lastIndex) + replaceValue;
  }
  return this.toString();
};

String.prototype.replaceLastOccurrence = function (searchValue: string, replaceValue: string = ''): string {
  return this.replace(new RegExp(searchValue + '([^' + searchValue + ']*)$'), replaceValue + '$1');
};

String.prototype.capitalize = function (): string {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
